import { getEmployeeNotice } from 'core'

import { useQueryParams, useQueryRequestV2 } from 'common/hooks'

const EmployeeNotice = () => {
  const params = useQueryParams()
  const code = params.get('code')
  const renewal = params.get('renewal')

  const { data: eeNotice } = useQueryRequestV2({
    queryFn: async () => {
      const pdf = await getEmployeeNotice(code, renewal)
      return downloadLink(pdf, 'ee-notice.html')
    },
  })

  const base64ToBlob = async (base64: string) => {
    const binaryString = window.atob(base64)
    const len = binaryString.length
    const bytes = new Uint8Array(len)
    for (let i = 0; i < len; ++i) {
      bytes[i] = binaryString.charCodeAt(i)
    }
    return new Blob([bytes], { type: 'application/pdf' })
  }

  const downloadLink = async (documentUrl: string, fileName: string) => {
    if (documentUrl) {
      var file = await base64ToBlob(documentUrl)
      if (file) {
        const nav = window.navigator as any
        if (nav && nav!.msSaveOrOpenBlob) {
          nav.msSaveOrOpenBlob(file, `${fileName}.pdf`)
        } else {
          var fileURL = URL.createObjectURL(file)
          window.open(fileURL, '_self')
        }
      }
    }
  }

  return <></>
}

export default EmployeeNotice
